import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/components/fields/confirmation-dialog/confirmation-dialog.component';
import { Helpers, Report } from 'src/app/model';
import { BVQReportProvider } from 'src/app/providers/bvq';
import { ReportService } from 'src/app/services/report.service';
import { LogService } from 'src/app/services';

@Component({
  selector: 'app-supplemental-link',
  templateUrl: './supplemental-link.modal.html',
  styleUrls: ['./supplemental-link.modal.scss']
})
export class SupplementalLinkModal implements OnInit {

  subject: Subject<boolean>;
  subscription: any;
  emailId: string = "";
  report: Report;
  reportSub:any;
  currentReport:any;


  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private bvqProvider: BVQReportProvider,
    private reportService:ReportService,
    private logService : LogService
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing

    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      if(currentReport){
        this.report = currentReport;

        if(this.report.BVQ){
          this.currentReport = this.report.BVQ;
        }
      }

    });
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  ngAfterViewInit(): void {
  }

  onSend(): void {
    this.bvqProvider.sendEmail(this.report.ID, this.emailId).subscribe(res => {
      if (res.success) {
        this.showSuccessDialog(this.emailId);
      }
    },err=>{
      this.logService.error(err);
    })
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }

  showSuccessDialog(emailId: string): void {
    const config = Helpers.getModalConfig();
    config.class = 'modal-dialog-centered';
    this.bsModalRef = this.modalService.show(ConfirmationDialogComponent, config);
    const ackSubject = new Subject<any>();
    this.bsModalRef.content.subject = ackSubject;
    this.bsModalRef.content.title = 'Success';
    this.bsModalRef.content.text = `Supplemental link has been sent to ${emailId}`;
    this.bsModalRef.content.actionButton = 'Ok';
    this.bsModalRef.content.showCancel = false;
  }


  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }
}
